import styled from 'styled-components/macro';

const FormControl = styled.div`
  margin-bottom: 2.5rem;
`;

export default FormControl;
